import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { axiosPost, PostHeaders } from "base/lib/api";
import { AxiosRequestConfig } from "axios";

function usePost<T, V extends {} = {}>(
  url: string,
  header?: {},
  config?: AxiosRequestConfig,
  options?: UseMutationOptions<T, any, V>
) {
  return useMutation({
    mutationFn: (params: V) => {
      return axiosPost<T>(
        url,
        params,
        header || PostHeaders,
        undefined,
        config
      );
    },
    ...options,
  });
}

export default usePost;
